export default __webpack_public_path__ + "static/media/match.473c3144.jfif";